import React from 'react';
import { GridColDef, GridRowParams, DataGridPro } from '@mui/x-data-grid-pro';
import { FormDialog } from '../../../form-dialog';
import { Box } from '../../../box';
import { Row } from '../../../row';
import { FormControl } from '../../../form-control/form-control';
import { Container } from '../../../container/container';
import { stringComparator } from '../../../../areas/search/utilities/sort-comparators';
import { Cell } from '../../../cell';
import { redirectToEntity } from '../../../../areas/search/utilities/redirect-to-entity';
import { useRowActions } from '../../../../areas/search/contextProviders/row-action-provider';
import { ICompanyBasicInfo } from './show-companies-dialog';

export interface IShowCompaniesDialogComponentProps {
  open: boolean;
  companies: ICompanyBasicInfo[];
  onClose: () => void;
  isLoading: boolean;
}

export function ShowCompaniesDialogComponent(props: IShowCompaniesDialogComponentProps) {
  const { open, companies, onClose, isLoading } = props;
  const rowActions = useRowActions();

  function onConfirm() {
    onClose && onClose();
  }
  const columns: GridColDef[] = [
    {
      field: 'cvrNumber',
      headerName: 'CVR-nr',
      sortComparator: stringComparator,
    },
    {
      field: 'name',
      headerName: 'Navn',
      description: '',
      flex: 1,
      sortComparator: stringComparator,
    },
  ];

  function handleRowClick(params: GridRowParams) {
    redirectToEntity(params, rowActions, 'company', 'company');
  }
  return (
    <FormDialog open={open} title="Valgte virksomheder" confirmButtonText="Luk" onConfirmClick={onConfirm} maxWidth="lg" isValid>
      <FormControl fullWidth>
        <Container>
          <Box width="500px">
            <Row>
              <Cell size="full">
                <DataGridPro
                  loading={isLoading}
                  rows={companies?.filter(x => !!x) || []}
                  columns={columns || []}
                  autoHeight
                  density="compact"
                  disableColumnMenu
                  pageSize={20}
                  onRowClick={handleRowClick}
                  pagination
                />
              </Cell>
            </Row>
          </Box>
        </Container>
      </FormControl>
    </FormDialog>
  );
}
